import { V2_FACTORY_ADDRESS, V2_INIT_CODE_HASH } from '@hyperswap/addresses/dist'
import JSBI from 'jsbi'

export const FACTORY_ADDRESS = V2_FACTORY_ADDRESS

export const INIT_CODE_HASH = V2_INIT_CODE_HASH

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const FIVE = JSBI.BigInt(5)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)
